// hooks/useSyncUrlFilters.ts
import { useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { handleSetAdvertListFilter } from "../apps/RealState/ListItems/ClientStates";
import dayjs from "dayjs";

export const useSyncUrlFilters = () => {
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();

  useEffect(() => {
    const params = Object.fromEntries(searchParams.entries());
    const newFilter: any = {};

    // Lokasyon filtreleri
    if (params.CityId) newFilter.CityId = Number(params.CityId);
    if (params.DistrictId) newFilter.DistrictIds = [Number(params.DistrictId)];
    if (params.NeighbourhoodId) newFilter.NeighbourhoodIds = [Number(params.NeighbourhoodId)];

    // Fiyat filtreleri
    if (params.MinPrice) newFilter.MinPrice = Number(params.MinPrice);
    if (params.MaxPrice) newFilter.MaxPrice = Number(params.MaxPrice);

    // Tarih filtreleri
    if (params.StartDate) newFilter.StartDate = params.StartDate;
    if (params.EndDate) newFilter.EndDate = params.EndDate;

    // Diğer filtreler
    if (params.EidsApproved) newFilter.EidsApproved = params.EidsApproved === 'true';
    if (params.fromWho) {
      newFilter.selectedOptionListObj = [{
        name: "Seçilen Firma Tipi",
        values: params.fromWho.split(',').map((key: string) => ({ key }))
      }];
    }

    if (Object.keys(newFilter).length > 0) {
      dispatch(handleSetAdvertListFilter({ filter: newFilter }));
    }
  }, [searchParams.toString()]);
};